import type { Capability, Engine } from './registry.ts';

/* Content Library nav (owner D1 24-10-2026): with content_library_v1 ON the
 * Content engine shows ONE "Library" entry (the console) and ONE "Create · AI
 * Studio" entry (the existing create page, same URL), instead of two items that
 * both pointed at /social/content-studio. Campaigns (soon) moves to the bottom.
 * Every other capability and route is unchanged. Flag OFF -> the registry as-is. */
export function contentLibraryCapabilities(engine: Engine, enabled: boolean): Capability[] {
  if (!enabled || engine.key !== 'social') return engine.capabilities;
  const out: Capability[] = [
    { key: 'library', label: 'Library', path: '/social/library' },
    { key: 'studio', label: 'Create · AI Studio', path: '/social/content-studio' },
  ];
  let campaigns: Capability | undefined;
  for (const c of engine.capabilities) {
    if (c.key === 'campaigns') { campaigns = c; continue; }
    if (c.key === 'content' || c.key === 'studio') continue;
    out.push(c);
  }
  if (campaigns) out.push(campaigns);
  return out;
}
